import React, { FC, useId } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Dialog from '@mui/material/Dialog';
import OvCompactButton from '../atoms/OvCompactButton';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvDiscardStagedFilesDialogProps {
  isOpen: boolean;
  onKeep: () => void;
  onDiscard: () => void;
}

const OvDiscardStagedFilesDialog: FC<OvDiscardStagedFilesDialogProps> = ({
  isOpen,
  onKeep,
  onDiscard,
}) => {
  const { t } = useTranslation();
  const titleId = useId();
  const bodyId = useId();

  return (
    <Dialog
      open={isOpen}
      onClose={onKeep}
      aria-labelledby={titleId}
      aria-describedby={bodyId}
      PaperProps={{
        style: {
          maxWidth: Variables.layout.DIALOG_COMPACT_WIDTH,
          borderRadius: Variables.borderRadius.LARGE,
        },
      }}
    >
      <Content>
        <h2 id={titleId}>{t('videos.staging.discardTitle')}</h2>
        <p id={bodyId}>{t('videos.staging.discardBody')}</p>
        <Actions>
          <OvCompactButton tone="secondary" onClick={onKeep} autoFocus>
            {t('videos.staging.keepPreparing')}
          </OvCompactButton>
          <OvCompactButton tone="danger" onClick={onDiscard}>
            {t('videos.staging.discardFiles')}
          </OvCompactButton>
        </Actions>
      </Content>
    </Dialog>
  );
};

export default OvDiscardStagedFilesDialog;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;
  color: ${Colours.OV_BASE};

  h2 {
    margin: 0;
    font-size: ${Variables.fontSizes.MLARGE};
    line-height: ${Variables.lineHeights.MLARGE};
  }

  p {
    margin: 0;
  }
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.75rem;
`;
